<ion-card>
  <ion-card-header>
    <ion-card-title>Családszerkesztő</ion-card-title>
    <ion-card-subtitle>
      A család a számlázás és a szülői nézetek egysége, és a gondviselő–tanuló kapcsolatokból
      áll össze: egy családba tartozik mindenki, aki kapcsolatokon át összeér. Külön taglista
      nincs. Egy tag felvétele kapcsolatot hoz létre a család tagjaival, a kivétele a kapcsolatait
      bontja – ettől függ az is, hogy a szülő melyik gyereket látja.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="osszesito">
      <span><b>{{ osszesites.csalad || 0 }}</b> család</span>
      <span [style.color]="osszesites.tanulo_csalad_nelkul ? '#c5221f' : '#137333'">
        <b>{{ osszesites.tanulo_csalad_nelkul || 0 }}</b> tanuló család nélkül
      </span>
      <span [style.color]="osszesites.szulo_csalad_nelkul ? '#8a6d00' : '#137333'">
        <b>{{ osszesites.szulo_csalad_nelkul || 0 }}</b> gondviselő család nélkül
      </span>
      <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>
    </div>

    <!-- DIAGNÓZIS: mi a baj, kit érint, mivel javítható. -->
    <div class="diagnozis" [class.rendben]="!diagnozis.length">
      <div class="diag-fejlec">
        <ion-icon [name]="diagnozis.length ? 'medkit-outline' : 'checkmark-circle-outline'"></ion-icon>
        <b>Diagnózis</b>
        <span *ngIf="!diagnozis.length">– nincs javítandó, a családok rendben vannak.</span>
      </div>

      <div class="diag-tetel" *ngFor="let d of diagnozis" [class]="'szint-' + d.szint">
        <div class="diag-sor">
          <div style="flex:1">
            <b>{{ d.cim }}</b>
            <div style="font-size:12px;margin-top:2px">{{ d.magyarazat }}</div>
          </div>
          <ion-button size="small" *ngIf="d.gomb" [color]="d.szint === 'hiba' ? 'danger' : 'warning'"
                      (click)="diagnozisMuvelet(d.muvelet)" [disabled]="osszevonasFut || toltodik">
            {{ d.gomb }}
          </ion-button>
        </div>
        <div class="diag-lista" *ngIf="d.tetelek?.length">
          <span class="diag-chip" *ngFor="let t of d.tetelek">
            {{ t.cimke }}<b *ngIf="t.db"> · {{ t.db }}</b>
          </span>
        </div>
      </div>

      <div style="font-size:11px;color:#667;margin-top:8px" *ngIf="diagnozis.length">
        A szülő belépéskor azokat a gyerekeket látja, akikhez <b>gondviselő-kapcsolata</b> van –
        nem azokat, akik vele egy családban vannak. A kettő eltérhet, ezért lehet a család
        hiánytalan úgy, hogy a szülő mégis csak az egyik gyerekét látja.
      </div>
    </div>

    <!-- DUPLIKÁLT GONDVISELŐK: a hiányzó kapcsolatok gyökere. Külön nyitható,
         mert az összevonás visszafordíthatatlan, és nem napi művelet. -->
    <div class="dupla-panel" *ngIf="duplikatumok.length">
      <div style="display:flex;align-items:center;gap:8px;cursor:pointer" (click)="duplaNyitva = !duplaNyitva">
        <ion-icon [name]="duplaNyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
        <b>Duplikált gondviselők ({{ duplikatumok.length }})</b>
        <span style="font-size:12px;color:#667">
          – ugyanaz a személy több felhasználónévvel; összevonhatók
        </span>
      </div>

      <div *ngIf="duplaNyitva" style="margin-top:10px">
        <!-- TÖMEGES: a rendszer szedi listába, nem kell egyesével végigkattintani. -->
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:10px">
          <ion-button size="small" color="secondary" (click)="tomegesProba()" [disabled]="osszevonasFut">
            <ion-icon slot="start" name="flask-outline"></ion-icon>Mind – próba
          </ion-button>
          <ion-button size="small" color="danger" (click)="tomegesOsszevon()"
                      [disabled]="!tomegesTerv || osszevonasFut">
            <ion-icon slot="start" name="git-merge-outline"></ion-icon>
            Mind összevonása{{ tomegesTerv ? ' (' + tomegesTerv.osszesites.osszevonhato + ')' : '' }}
          </ion-button>
          <ion-checkbox labelPlacement="end" [(ngModel)]="bizonytalanIs"
                        (ionChange)="tomegesTerv = null" style="font-size:13px">
            A bizonytalanok is
          </ion-checkbox>
          <ion-spinner name="crescent" *ngIf="osszevonasFut"></ion-spinner>
        </div>

        <div class="terv-doboz" *ngIf="tomegesTerv" style="margin-bottom:12px">
          <b>Tömeges próba – {{ tomegesTerv.osszesites.osszevonhato }} összevonható,
            {{ tomegesTerv.osszesites.kihagyva }} kihagyva,
            {{ tomegesTerv.osszesites.erintett_sor }} sor módosulna</b>
          <table style="width:100%;font-size:12px;border-collapse:collapse;margin-top:6px">
            <thead><tr style="text-align:left">
              <th style="padding:2px 6px">Megy</th><th style="padding:2px 6px">Név</th>
              <th style="padding:2px 6px">Megmarad</th><th style="padding:2px 6px">Beolvad</th>
              <th class="szam" style="padding:2px 6px">Sor</th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let t of tomegesTerv.tetelek" style="border-top:1px solid #dde4f0"
                  [style.opacity]="t.kihagyva ? .55 : 1">
                <td style="padding:2px 6px">
                  <input type="checkbox" *ngIf="!t.kihagyva" [checked]="tomegesBenne(t.megmarad)"
                         (change)="tomegesKihagyValt(t.megmarad, $any($event.target).checked)" />
                  <ion-icon *ngIf="t.kihagyva" name="alert-circle-outline" color="warning"></ion-icon>
                </td>
                <td style="padding:2px 6px">{{ t.nev }}</td>
                <td style="padding:2px 6px">{{ t.megmarad || '–' }}</td>
                <td style="padding:2px 6px">{{ (t.beolvad || t.fiokok || []).join(', ') }}</td>
                <td class="szam" style="padding:2px 6px">{{ t.sorok || 0 }}</td>
              </tr>
            </tbody>
          </table>
          <div style="font-size:11px;color:#8a6d00;margin-top:6px" *ngIf="tomegesTerv.osszesites.kihagyva">
            A ⚠ jelöltek kimaradnak: eltérő e-mail cím két adatos fiókon – könnyen két különböző,
            azonos nevű személy. Ha mégis össze kell vonni, pipáld be „A bizonytalanok is" kapcsolót,
            vagy intézd egyesével.
          </div>
          <div style="font-size:11px;color:#667;margin-top:4px">
            A pipa kivételével egy-egy tétel kihagyható; a lista a próba után frissül.
          </div>
        </div>

        <div class="dupla-sor" *ngFor="let j of duplikatumok">
          <div style="flex:1">
            <b>{{ j.nev }}</b>
            <ion-badge color="warning" *ngIf="j.bizonytalan" style="margin-left:6px">ellenőrizd</ion-badge>
            <div style="font-size:12px;color:#667">
              <span *ngFor="let f of j.fiokok; let i = index">{{ i ? ' · ' : '' }}{{ f.username }}</span>
            </div>
          </div>
          <ion-button size="small" fill="outline" (click)="osszevonasIndit(j)">Összevonás…</ion-button>
        </div>
      </div>
    </div>

    <!-- Az összevonás munkalapja -->
    <div class="dupla-panel munkalap" *ngIf="osszevonas">
      <h4 style="margin:0 0 6px">Összevonás – {{ osszevonas.nev }}</h4>

      <div class="hiany-doboz" *ngIf="osszevonas.bizonytalan">
        <b>Ellenőrizd, mielőtt összevonod!</b>
        <div style="font-size:12px;margin-top:2px">{{ osszevonas.bizonytalan_ok }}</div>
      </div>

      <table style="width:100%;font-size:13px;border-collapse:collapse">
        <thead><tr style="text-align:left">
          <th style="padding:3px 6px">Megmarad</th><th style="padding:3px 6px">Beolvad</th>
          <th style="padding:3px 6px">Felhasználónév</th><th style="padding:3px 6px">E-mail</th>
          <th class="szam" style="padding:3px 6px">Számla</th>
          <th class="szam" style="padding:3px 6px">Kérvény</th>
          <th class="szam" style="padding:3px 6px">Kapcsolat</th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let f of osszevonas.fiokok" style="border-top:1px solid #e3e7ee">
            <td style="padding:3px 6px">
              <input type="radio" [checked]="osszevonas.megmarad === f.username"
                     (change)="megmaradValt(f.username)" />
            </td>
            <td style="padding:3px 6px">
              <input type="checkbox" *ngIf="osszevonas.megmarad !== f.username"
                     [checked]="osszevonas.beolvad.includes(f.username)"
                     (change)="beolvadValt(f.username, $any($event.target).checked)" />
            </td>
            <td style="padding:3px 6px">{{ f.username }}</td>
            <td style="padding:3px 6px">{{ f.email || '–' }}</td>
            <td class="szam" style="padding:3px 6px">{{ f.szamla }}</td>
            <td class="szam" style="padding:3px 6px">{{ f.kerveny }}</td>
            <td class="szam" style="padding:3px 6px">{{ f.kapcsolat }}</td>
          </tr>
        </tbody>
      </table>

      <div style="display:flex;gap:8px;margin-top:10px;flex-wrap:wrap">
        <ion-button size="small" color="secondary" (click)="proba()" [disabled]="osszevonasFut">
          <ion-icon slot="start" name="flask-outline"></ion-icon>Próba (nem ír semmit)
        </ion-button>
        <ion-button size="small" color="danger" (click)="osszevon()"
                    [disabled]="!terv || osszevonasFut">
          <ion-icon slot="start" name="git-merge-outline"></ion-icon>Összevonás véglegesen
        </ion-button>
        <ion-button size="small" fill="clear" (click)="osszevonas = null; terv = null">Mégse</ion-button>
        <ion-spinner name="crescent" *ngIf="osszevonasFut"></ion-spinner>
      </div>
      <div style="font-size:11px;color:#667;margin-top:4px">
        Az összevonás csak a próba lefuttatása után indítható.
      </div>

      <!-- A próba eredménye: pontosan mi változna -->
      <div class="terv-doboz" *ngIf="terv">
        <b>Próba eredménye – {{ tervOsszesen }} sor változna</b>
        <table style="width:100%;font-size:12px;border-collapse:collapse;margin-top:4px">
          <tr *ngFor="let t of terv.terv" [style.opacity]="t.db ? 1 : .45">
            <td style="padding:2px 6px">{{ t.leiras }}</td>
            <td style="padding:2px 6px;color:#889">{{ t.tabla }}.{{ t.oszlop }}</td>
            <td class="szam" style="padding:2px 6px"><b>{{ t.db }}</b></td>
          </tr>
        </table>
        <div style="margin-top:6px" *ngIf="terv.atveendo && (terv.atveendo | keyvalue).length">
          Átvett hiányzó adatok:
          <span *ngFor="let m of terv.atveendo | keyvalue; let i = index">{{ i ? ', ' : '' }}{{ m.key }}</span>
        </div>
        <div style="margin-top:6px">
          Törlődő gondviselő-rekord: <b>{{ terv.torlendo_szulo?.join(', ') }}</b>
        </div>
        <div style="margin-top:6px;color:#8a6d00;font-size:12px">{{ terv.figyelmeztetes }}</div>
      </div>
    </div>

    <div class="csalad-grid">
      <!-- BAL: családlista -->
      <div>
        <div style="display:flex;gap:6px;align-items:center;margin-bottom:6px">
          <ion-input fill="outline" placeholder="Keresés név vagy azonosító szerint"
                     [(ngModel)]="csaladSzuro" style="flex:1"></ion-input>
          <ion-button size="small" [fill]="csakHianyos ? 'solid' : 'outline'" color="warning"
                      (click)="csakHianyos = !csakHianyos" title="Csak a hiányos családok">
            <ion-icon slot="icon-only" name="unlink-outline"></ion-icon>
          </ion-button>
          <ion-button size="small" (click)="ujCsalad()">
            <ion-icon slot="icon-only" name="add"></ion-icon>
          </ion-button>
        </div>

        <div class="csalad-lista">
          <div class="csalad-sor" *ngFor="let cs of szurtCsaladok"
               [class.aktiv]="kivalasztott?.csalad === cs.csalad" (click)="valaszt(cs)">
            <!-- Az egyesítéshez a CÉL a kiválasztott család, a pipa a forrásokat jelöli. -->
            <input type="checkbox" *ngIf="kivalasztott?.csalad && kivalasztott.csalad !== cs.csalad"
                   [checked]="egyesitendo.includes(cs.csalad)" (click)="$event.stopPropagation()"
                   (change)="egyesitesValt(cs.csalad, $any($event.target).checked)"
                   title="Egyesítés a kiválasztott családba" />
            <div style="flex:1;min-width:0">
              <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ cs.cimke }}</div>
              <div class="meta">
                {{ cs.tanulok.length }} tanuló · {{ cs.szulok.length }} gondviselő
                <span *ngIf="cs.hianyzo_kapcsolat?.length" style="color:#c5221f">
                  · {{ cs.hianyzo_kapcsolat.length }} hiányzó kapcsolat
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="!szurtCsaladok.length" style="padding:10px;color:#888">Nincs találat.</div>
        </div>

        <!-- Akiknek nincs családjuk: ezekkel kell kezdeni -->
        <div *ngIf="csaladNelkul.length">
          <div class="blokk-cim">Család nélkül ({{ csaladNelkul.length }})</div>
          <div class="talalat-lista">
            <div class="talalat" *ngFor="let t of csaladNelkul"
                 (click)="kivalasztott ? hozzaad(t) : null"
                 [title]="kivalasztott ? 'Hozzáadás a kiválasztott családhoz' : 'Előbb válassz családot'">
              <span>
                <ion-icon [name]="t.tipus === 'tanulo' ? 'school-outline' : 'person-outline'"></ion-icon>
                {{ t.nev || t.azonosito }}
                <span class="azon" *ngIf="t.osztaly"> · {{ t.osztaly }}</span>
              </span>
              <ion-icon name="add-circle-outline" *ngIf="kivalasztott"></ion-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- JOBB: a kiválasztott család -->
      <div>
        <ion-note color="medium" *ngIf="!kivalasztott">
          Válassz egy családot a listából, vagy hozz létre újat a + gombbal.
        </ion-note>

        <div *ngIf="kivalasztott">
          <h3 style="margin:0 0 4px">{{ kivalasztott.cimke || '(új család)' }}</h3>
          <div style="font-size:11px;color:#889;margin-bottom:8px" *ngIf="kivalasztott.csalad">
            azonosító: {{ kivalasztott.csalad }}
          </div>

          <div class="blokk-cim">Tanulók ({{ tanuloTagok.length }})</div>
          <div class="tag-lista">
            <span class="tag tanulo" *ngFor="let t of tanuloTagok" [class.ismeretlen]="t.ismeretlen">
              {{ t.nev || t.azonosito }}
              <span class="azon" *ngIf="t.osztaly">{{ t.osztaly }}</span>
              <span class="azon" *ngIf="t.ismeretlen" title="Nem található az intézmény törzsében">?</span>
              <span class="x" (click)="kivesz(t)">×</span>
            </span>
            <span *ngIf="!tanuloTagok.length" style="color:#888;font-size:13px">Nincs tanuló a családban.</span>
          </div>

          <div class="blokk-cim">Gondviselők ({{ szuloTagok.length }})</div>
          <div class="tag-lista">
            <span class="tag szulo" *ngFor="let t of szuloTagok" [class.ismeretlen]="t.ismeretlen">
              {{ t.nev || t.azonosito }}
              <span class="azon">{{ t.azonosito }}</span>
              <span class="x" (click)="kivesz(t)">×</span>
            </span>
            <span *ngIf="!szuloTagok.length" style="color:#888;font-size:13px">Nincs gondviselő a családban.</span>
          </div>

          <!-- HIÁNYZÓ GONDVISELŐ-KAPCSOLATOK: ettől lát a szülő kevesebb gyereket. -->
          <div class="hiany-doboz" *ngIf="hianyzoKapcsolatok.length">
            <b>{{ hianyzoKapcsolatok.length }} hiányzó gondviselő-kapcsolat</b>
            <div style="font-size:12px;margin:4px 0 6px">
              Ezek a szülők nem látják belépéskor a felsorolt gyereket, pedig egy családban vannak:
            </div>
            <div style="font-size:12px;max-height:140px;overflow:auto">
              <div *ngFor="let h of hianyzoKapcsolatok">
                • {{ h.szulo_nev || h.szulo }} <span style="opacity:.6">({{ h.szulo }})</span>
                → {{ h.tanulo_nev || h.tanulo }}
              </div>
            </div>
          </div>

          <!-- Ugyanaz a személy több fiókkal – a hiány gyökere, de a fiókok összevonása
               belépést érintő művelet, ezért csak jelezzük. -->
          <div class="hiany-doboz info" *ngIf="duplaSzulok.length">
            <b>Ugyanaz a gondviselő több felhasználónévvel</b>
            <div style="font-size:12px;margin-top:4px" *ngFor="let cso of duplaSzulok">
              • {{ cso[0].nev }}: <span *ngFor="let t of cso; let i = index">{{ i ? ', ' : '' }}{{ t.azonosito }}</span>
            </div>
            <div style="font-size:11px;color:#667;margin-top:4px">
              A felhasználónév a gyerek azonosítójából képződik, ezért testvéreknél két fiók jön
              létre ugyanannak a szülőnek. A kapcsolatok pótlása után bármelyik fiókkal belépve
              mindkét gyerek látszik; a fiókok összevonása külön, belépést érintő művelet.
            </div>
          </div>

          <div class="blokk-cim">Tag hozzáadása</div>
          <ion-input fill="outline" [(ngModel)]="keresoSzoveg"
                     placeholder="Tanuló vagy gondviselő neve, azonosítója, osztálya (min. 2 karakter)"></ion-input>
          <div class="talalat-lista" *ngIf="talalatok.length" style="margin-top:6px">
            <div class="talalat" *ngFor="let t of talalatok" (click)="hozzaad(t)">
              <span>
                <ion-icon [name]="t.tipus === 'tanulo' ? 'school-outline' : 'person-outline'"></ion-icon>
                {{ t.nev || t.azonosito }}
                <span class="azon" *ngIf="t.osztaly"> · {{ t.osztaly }}</span>
                <span class="azon" *ngIf="t.tipus !== 'tanulo'"> · {{ t.azonosito }}</span>
              </span>
              <!-- Előre megmondjuk, ha a tag elvétele másik családot érint. -->
              <span class="figyelem" *ngIf="t.jelenlegiCsalad">
                jelenleg: {{ t.jelenlegiCsalad.cimke }}
              </span>
            </div>
          </div>

          <div style="margin-top:12px">
            <ion-checkbox labelPlacement="end" [(ngModel)]="kapcsolatokPotlasa">
              A család minden gondviselője kapcsolódjon a család minden gyerekéhez
            </ion-checkbox>
            <div style="font-size:11px;color:#667;margin-top:2px">
              Kikapcsolva csak a felvett tag kapcsolódik a család tagjaihoz. Két anyától született
              testvéreknél hagyd kikapcsolva: különben az egyik anya a másik gyerekhez is jogot kapna.
            </div>
          </div>

          <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:12px">
            <ion-button size="small" color="success" (click)="mentes()">
              <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
            </ion-button>
            <ion-button size="small" color="secondary" *ngIf="kivalasztott.csalad && egyesitendo.length"
                        (click)="egyesites()">
              <ion-icon slot="start" name="git-merge-outline"></ion-icon>
              {{ egyesitendo.length }} család egyesítése ide
            </ion-button>
          </div>
          <ion-note color="medium" style="display:block;margin-top:8px;font-size:12px"
                    *ngIf="kivalasztott.csalad && !egyesitendo.length">
            Testvér másik családból: pipáld be a bal oldali listában azt a családot, amelyiket
            ide olvasztanád, majd nyomd meg az egyesítést.
          </ion-note>
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
